
















import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Container from '@/components/layout/Container.vue';
import SectionCard from '@/components/landing/SectionCard.vue';
import FlatButton from '@/components/common/FlatButton.vue';
import PortalIcon from '@/components/icons/PortalIcon.vue';

import LocaleMixin from '@/mixins/locale';

import { buildHelpshiftUrl } from '@/helpers/external';

@Component({
  components: { PortalIcon, FlatButton, Container, SectionCard },
})
export default class SupportSection extends mixins(LocaleMixin) {
  get url() {
    return buildHelpshiftUrl(this.locale, this.$appName);
  }
}
